export enum ORGANIZATION_TYPE {
  BANK = "BANK",
  INSURANCE = "INSURANCE",
  OFF_TAKER = "OFF_TAKER",
  INPUT_SUPPLIER = "INPUT_SUPPLIER",
  AGRO_DEALER = "AGRO_DEALER",
  SHEGA_FRE = "SHEGA_FRE",
}

export const RegularExpression = {
  name: /^[a-zA-Z\s\.]*$/,
  userName: /^[a-zA-Z]*$/,
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  phoneNo: /^[0-9]{10}$/,
  woreda: /^[0-9]{1,2}$/,
  kebele: /^[0-9]{1,2}$/,
  houseNumber: /^[0-9]{1,4}$/,
  quantity: /^[0-9]+$/,
  date: /^\d{4}\-\d{2}\-\d{2}$/,
  bankAccount:/^\d{10,13}$/,
};
